import {AgentStub} from "../rpc/webrpc-client.gen.ts";
import i18next from "i18next";

export const unknownAuthor: AgentStub = {
    id: "0",
    displayName: i18next.t("unknown"),
    code: "<unknown>",
};

